import { render, staticRenderFns } from "./AiResponses.vue?vue&type=template&id=36e4138c&scoped=true"
import script from "./AiResponses.vue?vue&type=script&setup=true&lang=js"
export * from "./AiResponses.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e4138c",
  null
  
)

export default component.exports